var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#006747;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-271.59998)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.9,277.9c-0.4,0-0.8,0.1-1.2,0.3l-26.2,9.5h34.1l-2.6-7c-0.6-1.6-2.1-2.7-3.7-2.8 C45.1,277.9,45,277.9,44.9,277.9z M6.3,290.4c-2.3,0-4.2,1.9-4.2,4.2v32.1c0,2.3,1.9,4.2,4.2,4.2h47.4c2.3,0,4.2-1.9,4.2-4.2v-32.1 c0-2.3-1.9-4.2-4.2-4.2H6.3z M4.9,301.6h50.2v25.1c0,0.8-0.6,1.4-1.4,1.4H6.3c-0.8,0-1.4-0.6-1.4-1.4V301.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,272.3c-1.3-0.1-2.6,0.1-3.8,0.6l-6.9,2.5c-0.7,0.2-1.1,1-0.9,1.8s1,1.1,1.8,0.9h0.1l6.9-2.5 c0.9-0.3,1.8-0.5,2.7-0.4c2.7,0.1,5.2,1.9,6.2,4.6c0.2,0.7,1,1.1,1.8,0.9c0.7-0.2,1.1-1,0.9-1.8v-0.1 C52.9,275,49.4,272.5,45.6,272.3z M30.6,277.1c-0.2,0-0.3,0-0.5,0.1l-3,1.1c-0.7,0.3-1.1,1.1-0.8,1.8c0.3,0.7,1.1,1.1,1.8,0.8l0,0 l3-1.1c0.7-0.3,1.1-1,0.9-1.8C31.7,277.4,31.1,277.1,30.6,277.1L30.6,277.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,312.8c-1.4,0-2.8,1.4-2.8,2.8v5.6c0,1.4,1.4,2.8,2.8,2.8h8.4c1.4,0,2.8-1.4,2.8-2.8v-5.6 c0-1.4-1.4-2.8-2.8-2.8H11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,321.1c-0.8,0-1.4,0.5-1.5,1.3c0,0.8,0.5,1.4,1.3,1.5c0.1,0,0.1,0,0.2,0h16.7c0.8,0,1.4-0.5,1.5-1.3 c0-0.8-0.5-1.4-1.3-1.5c-0.1,0-0.1,0-0.2,0H32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,315.6c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4l0,0h7c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4l0,0H32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.3,316.9c0,0.8-0.6,1.4-1.4,1.4l0,0c-0.8,0-1.4-0.6-1.4-1.4l0,0c0-0.8,0.6-1.4,1.4-1.4l0,0 C44.7,315.6,45.3,316.2,45.3,316.9L45.3,316.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/CreditCardIcon.cacd9c6df1c358ccea0dd5a4a6706449.svg";
export { ForwardRef as ReactComponent };